import client from './client';

export const getWithdrawals = (params) => client.get('/withdrawals', { params });

export const getWithdrawalDetail = (id) => client.get(`/withdrawals/${id}`);

export const approveWithdrawal = (id) => client.post(`/withdrawals/${id}/approve`);

export const rejectWithdrawal = (id, data) => client.post(`/withdrawals/${id}/reject`, data);
